import axios from "axios";
import envConfig from "./env_config";
import {
  isTokenExpired,
  refreshAuthToken,
  // handleFailedRefresh,
} from "./helper_functions";
import { TENANT_CORE_API_KEY } from "../Tenant-Config/TenantConfig";

export const axiosApi = axios.create();

axiosApi.interceptors.request.use(
  async (config) => {
    config.headers = config.headers || {};
    config.headers["X-TENANT-CORE-API-KEY"] = TENANT_CORE_API_KEY;
    if (config._skipAuth) {
      return config;
    }
    const hasCustomAuth =
      config.headers.Authorization || config.headers.authorization;
    if (hasCustomAuth) {
      return config;
    }
    const token =
      localStorage.getItem("token") || localStorage.getItem("access_token");
    const tokenExpiry = localStorage.getItem("tokenExpiry");
    if (token && tokenExpiry && isTokenExpired(tokenExpiry)) {
      try {
        await refreshAuthToken();
        config.headers["Authorization"] =
          "Bearer " + localStorage.getItem("token");
      } catch (error) {        
        console.log("error", error);
        return Promise.reject(error);
      }
    } else if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (originalRequest?._skipAuth) {
      return Promise.reject(error);
    }
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshSuccess = await refreshAuthToken();
        if (!refreshSuccess) {
          // handleFailedRefresh();
          return Promise.reject(error);
        }
        const newToken = localStorage.getItem("token");
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosApi(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);
        // handleFailedRefresh();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);

export async function get(baseURL, url, requestConfig) {
  if (typeof url !== "string") {
    console.error("Invalid URL in post request:", url);
    throw new Error("Invalid URL provided to API helper");
  }
  axiosApi.defaults.baseURL = baseURL || envConfig.baseURLs.vyLabsBaseURL;
  return await axiosApi
    .get(url, { ...requestConfig })
    .then((response) => response.data);
}

export async function post(baseURL, url, data, requestConfig) {
  if (typeof url !== "string") {
    console.error("Invalid URL in post request:", url);
    throw new Error("Invalid URL provided to API helper");
  }
  axiosApi.defaults.baseURL = baseURL || envConfig.baseURLs.vyLabsBaseURL;
  return await axiosApi
    .post(url, data, { ...requestConfig })
    .then((response) => response.data);
}

export async function deleteRequest(baseURL, url, data, requestConfig) {
  if (typeof url !== "string") {
    console.error("Invalid URL in delete request:", url);
    throw new Error("Invalid URL provided to API helper");
  }

  axiosApi.defaults.baseURL = baseURL || envConfig.baseURLs.vyLabsBaseURL;

  return await axiosApi
    .delete(url, {
      data,
      ...requestConfig,
    })
    .then((response) => response.data);
}

export async function put(baseURL, url, data, requestConfig) {
  if (typeof url !== "string") {
    console.error("Invalid URL in post request:", url);
    throw new Error("Invalid URL provided to API helper");
  }
  axiosApi.defaults.baseURL = baseURL || envConfig.baseURLs.vyLabsBaseURL;
  return await axiosApi
    .put(url, data, { ...requestConfig })
    .then((response) => response.data);
}

export async function patch(baseURL, url, data, requestConfig) {
  if (typeof url !== "string") {
    console.error("Invalid URL in patch request:", url);
    throw new Error("Invalid URL provided to API helper");
  }
  axiosApi.defaults.baseURL = baseURL || envConfig.baseURLs.vyLabsBaseURL;
  return await axiosApi
    .patch(url, data, { ...requestConfig })
    .then((response) => response.data);
}
